import React from "react";
import classes from "./rabbitIllustrations.module.css";

const catIllustrations = () => {
  return (
    <div className={classes.illustrationsContainer}>
      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* White dwarf cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            <ellipse
              cx="50"
              cy="70"
              rx="25"
              ry="35"
              fill="#FFFFFF"
              stroke="#DDDDDD"
              strokeWidth="1"
            />
            <ellipse
              cx="35"
              cy="40"
              rx="8"
              ry="20"
              fill="#FFFFFF"
              stroke="#DDDDDD"
              strokeWidth="1"
            />
            <ellipse
              cx="65"
              cy="40"
              rx="8"
              ry="20"
              fill="#FFFFFF"
              stroke="#DDDDDD"
              strokeWidth="1"
            />
            <ellipse cx="42" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="58" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="50" cy="70" rx="4" ry="2" fill="#FFAAAA" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔷 Snowball</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Brown lop cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            <ellipse
              cx="50"
              cy="70"
              rx="25"
              ry="35"
              fill="#C28F60"
              stroke="#B27F50"
              strokeWidth="1"
            />
            <ellipse
              cx="30"
              cy="45"
              rx="15"
              ry="8"
              fill="#C28F60"
              stroke="#B27F50"
              strokeWidth="1"
              transform="rotate(-20 30 45)"
            />
            <ellipse
              cx="70"
              cy="45"
              rx="15"
              ry="8"
              fill="#C28F60"
              stroke="#B27F50"
              strokeWidth="1"
              transform="rotate(20 70 45)"
            />
            <ellipse cx="42" cy="65" rx="3" ry="3" fill="#553311" />
            <ellipse cx="58" cy="65" rx="3" ry="3" fill="#553311" />
            <ellipse cx="50" cy="70" rx="4" ry="2" fill="#FFAAAA" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔶 Cinnamon</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Spotted cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            <ellipse
              cx="50"
              cy="70"
              rx="25"
              ry="35"
              fill="#FFFFFF"
              stroke="#DDDDDD"
              strokeWidth="1"
            />
            <ellipse
              cx="35"
              cy="40"
              rx="8"
              ry="20"
              fill="#FFFFFF"
              stroke="#DDDDDD"
              strokeWidth="1"
            />
            <ellipse
              cx="65"
              cy="40"
              rx="8"
              ry="20"
              fill="#FFFFFF"
              stroke="#DDDDDD"
              strokeWidth="1"
            />
            <circle cx="60" cy="60" r="7" fill="#333333" />
            <circle cx="40" cy="80" r="8" fill="#333333" />
            <circle cx="55" cy="90" r="5" fill="#333333" />
            <ellipse cx="42" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="58" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="50" cy="70" rx="4" ry="2" fill="#FFAAAA" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔷 Patches</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Gray cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            <ellipse
              cx="50"
              cy="70"
              rx="25"
              ry="35"
              fill="#AAAAAA"
              stroke="#999999"
              strokeWidth="1"
            />
            <ellipse
              cx="35"
              cy="40"
              rx="8"
              ry="20"
              fill="#AAAAAA"
              stroke="#999999"
              strokeWidth="1"
            />
            <ellipse
              cx="65"
              cy="40"
              rx="8"
              ry="20"
              fill="#AAAAAA"
              stroke="#999999"
              strokeWidth="1"
            />
            <ellipse cx="42" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="58" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="50" cy="70" rx="4" ry="2" fill="#FFAAAA" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔶 Luna</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Cream-colored cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            <ellipse
              cx="50"
              cy="70"
              rx="25"
              ry="35"
              fill="#F5E7C1"
              stroke="#E5D7B1"
              strokeWidth="1"
            />
            <ellipse
              cx="35"
              cy="40"
              rx="8"
              ry="20"
              fill="#F5E7C1"
              stroke="#E5D7B1"
              strokeWidth="1"
            />
            <ellipse
              cx="65"
              cy="40"
              rx="8"
              ry="20"
              fill="#F5E7C1"
              stroke="#E5D7B1"
              strokeWidth="1"
            />
            <ellipse cx="42" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="58" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="50" cy="70" rx="4" ry="2" fill="#FFAAAA" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔷 Biscuit</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Black and white cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            <ellipse
              cx="50"
              cy="70"
              rx="25"
              ry="35"
              fill="#000000"
              stroke="#222222"
              strokeWidth="1"
            />
            <ellipse
              cx="35"
              cy="40"
              rx="8"
              ry="20"
              fill="#000000"
              stroke="#222222"
              strokeWidth="1"
            />
            <ellipse
              cx="65"
              cy="40"
              rx="8"
              ry="20"
              fill="#000000"
              stroke="#222222"
              strokeWidth="1"
            />
            <path d="M30,60 Q50,85 70,60" fill="#FFFFFF" />
            <ellipse cx="42" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="58" cy="65" rx="3" ry="3" fill="#FF9999" />
            <ellipse cx="50" cy="70" rx="4" ry="2" fill="#FFAAAA" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔶 Oreo</span>
        </div>
      </div>
    </div>
  );
};

export default catIllustrations;
